import { render, staticRenderFns } from "./UiNotificationItem.vue?vue&type=template&id=104963fe&lang=pug&"
import script from "./UiNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./UiNotificationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports